export default {
    to: "/dashboard/sasapay-products/b2c-c2b",
    order: 3,
    icon: "mdi-google-my-business",
    title: "B2C/B2B",
    disabled: false,
    value: 0,
    // sublinks: [
    //     {
    //         to: "/dashboard/sasapay-products/business-to-customer",
    //         order: 3,
    //         icon: "mdi-account-supervisor-circle-outline",
    //         title: "Business To Customer",
    //         disabled: false,
    //         value: 0,
    //     },
    //     {
    //         to: "/dashboard/sasapay-products/business-to-business",
    //         order: 3,
    //         icon: "mdi-credit-card-check",
    //         title: "Business To Business",
    //         disabled: false,
    //         value: 0,
    //     },
    //     // {
    //     //     to: "/dashboard/sasapay-products/business-to-beneficiary",
    //     //     order: 3,
    //     //     icon: "mdi-mailbox-up-outline",
    //     //     title: "Business To Beneficiary",
    //     //     disabled: false,
    //     //     value: 0,
    //     // },
    // ],
}
